import PrivateBusRequestsResource from "./privateBusRequests.resource";

const privateBusRequestsModule = angular
  .module("app.resources.privateBusRequests", [])
  .service("PrivateBusRequests", PrivateBusRequestsResource);

export default privateBusRequestsModule;



// WEBPACK FOOTER //
// ./src/resources/privateBusRequests/privateBusRequests.module.js